module Meevo.Plugins.FieldLabels {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        protected businessTypeDetail: Model.BusinessTypeDetail = {};
        protected labels = []
        public labelPattern = {};

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)       
        }

        activate(): void {
            super.activate();
            this.labels = Object.keys(_.omit(this.model, ['groupEnum', 'settings']));

            const defaultLabelRegex = "^[a-zA-Z\\s]{3,20}$";
            const overrideLabelRegex = {
                giftCard: "^[a-z A-Z\/s]{3,25}$",
                promotionalGiftCard: "^[a-z A-Zs]{3,25}$"
            }

            this.labelPattern = this.labels.reduce((acc, label) => {                
                acc[label] = {
                    regEx: overrideLabelRegex[label] || defaultLabelRegex,
                    patternError: (label === 'giftCard' || label === 'promotionalGiftCard')
                        ? 'LABEL_FIELDLABELS_GIFTCARD_REGEXP_ERROR'
                        : 'LABEL_FIELDLABELS_REGEXP_ERROR'
                };
                return acc;
            }, {});
        }

        public updateModel(): void {

            let uri = `/${Meevo.AppSettings.Default.API_ROOT}/${Meevo.AppSettings.Default.API_ENDPOINTS.fieldLabels}`

            if (this.businessTypeDetail) {
                this.model.businessTypeId = this.businessTypeDetail.id;
                let parameters = {
                    businessTypeId: this.model.businessTypeId
                }
                this.dataService.customMethodData(uri, 'GET', '', parameters).then((results: any) => {
                    let temp = this.businessTypeDetail;
                    this.model = results.data;
                    this.businessTypeDetail = temp;
                });
            }
        }

        public isValid(label: any): void {
            let values = _.values(_.omit(this.model, ['groupEnum', 'settings'])).join('|').toLowerCase().split('|');
            let key = Model.Guard.isSomething(this.model[label])?  this.model[label].toLowerCase() : ''
            let groups = _.countBy(values, (v: any) => { return v == key ? 'Count' : 'Others' });

            if (_.has(groups, 'Count') && groups['Count'] > 1) {
                this.modalService.alert('LABEL_FIELDLABELS_DUPLICATE_NAME')
                    .then((res) => {
                        this.model[label] = null
                    })
            }

        }

        public preSave(): void {
            let labels = <Meevo.Model.FieldLabels>this.model
            super.preSave();

        }

    }
}